import axios from 'axios';

export default axios.create({
  // baseURL: `https://rapat-ars-api.uajy.ac.id/api/`,
  baseURL: `https://api-sira.arkin-dev.com/api/`,
  // baseURL: `http://127.0.0.1:8000/api/`,
});
